import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fcd0e46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "output__item" }
const _hoisted_2 = { class: "output__item-header" }
const _hoisted_3 = {
  key: 0,
  class: "output__item-content"
}
const _hoisted_4 = { style: {"margin-top":"20px"} }
const _hoisted_5 = {
  key: 1,
  class: "output__item-content"
}
const _hoisted_6 = { style: {"margin-top":"20px"} }

import { ref, toRefs, watch } from 'vue';
import { SettingsStore, useSettingsStore } from '@/store/settings';
import MyBtn from './UI/MyBtn.vue';
import ListOutputBlocks from './ListOutputBlocks.vue';

interface IListOutputItemProps {
  index: number;
  title: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListOutputItem',
  props: {
    index: {},
    title: {}
  },
  setup(__props: any) {

const props = __props;



const { index, title } = toRefs(props);

const settingsStore: SettingsStore = useSettingsStore();
const { changeMix, mix, settings } = settingsStore;

const toMix = ref(false);
const isVisible = ref(false);

watch(
  settings[index.value],
  () => {
    const visibleOptions = settings[index.value].filter((option) => option.visibility);
    if (visibleOptions.length) {
      isVisible.value = true;
    } else {
      isVisible.value = false;
    }
  },
  { deep: true },
);

const onMixClick = () => {
  toMix.value = !toMix.value;
  changeMix(index.value, toMix.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_unref(title)), 1),
        (isVisible.value)
          ? (_openBlock(), _createBlock(MyBtn, {
              key: 0,
              title: _unref(mix)[_unref(index) - 1] ? 'Сортировать' : 'Перемешать',
              "on-btn-click": onMixClick
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      (isVisible.value && !_unref(mix)[_unref(index) - 1])
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings)[_unref(index)], (_, i) => {
                return (_openBlock(), _createBlock(ListOutputBlocks, {
                  key: i,
                  "settings-index": _unref(index),
                  "settings-item-index": i
                }, null, 8, ["settings-index", "settings-item-index"]))
              }), 128))
            ])
          ]))
        : (isVisible.value && _unref(mix)[_unref(index) - 1])
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createBlock(ListOutputBlocks, {
                  key: _unref(index),
                  "settings-index": _unref(index),
                  "settings-item-index": _unref(index),
                  mixed: ""
                }, null, 8, ["settings-index", "settings-item-index"]))
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})